import _ from "lodash";
import client from "lib/apolloClient/client";
import { organizationUnitPlanFeedFragment } from "./AssessmentSelectModalFragments";
import { getUnitSectionFilterDataQuery } from "./AssessmentSelectModalQueries";

export const getOrganizationUnitPlanFeedV2FromCache = ({
  id,
  filters,
  showCollaborators = true,
  centralRepoInput,
}) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Organization:${id}`,
      fragment: organizationUnitPlanFeedFragment.organizationUnitPlanFeedV2,
      fragmentName: "organizationUnitPlanFeedItem",
      variables: {
        filters,
        showCollaborators,
        centralRepoInput,
      },
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};

export const getUnitSectionFilterDataFromCache = ({
  organizationId,
  coursesFilters,
  skipSubjects,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getUnitSectionFilterDataQuery,
      variables: {
        organizationId,
        coursesFilters,
        skipSubjects,
      },
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};
